import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class AccountIdentityVerificationRepositoryService extends BaseRepositoryService<
  ModelRegistry['account-identity-verification']
> {
  recordName = 'account-identity-verification';
  implementMethods = ['findRecord'];

  get defaultParams() {
    return {
      id: 'me',
    };
  }

  public async fetchCurrent(): Promise<
    ModelRegistry['account-identity-verification']
  > {
    return await this.findRecord('me', { reload: true });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/account-identity-verification': AccountIdentityVerificationRepositoryService;
  }
}
